import './HoverFlipTile.scss';

document.addEventListener("DOMContentLoaded", function() {
	const hoverFlipTiles = document.querySelectorAll(".hoverFlipTile");
  
	hoverFlipTiles.forEach(tile => {
	  tile.addEventListener("click", function(event) {
		if (isMobileDevice()) {
		  this.classList.toggle("active");
		}
	  });
	});
  
	function isMobileDevice() {
	  return window.innerWidth < 768;
	}
  });
